"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _isEmpty = _interopRequireDefault(require("lodash/isEmpty"));

var _urlHelper = require("@eig-builder/core-utils/helpers/url-helper");

var _runtimeConfigHelper = require("@eig-builder/core-utils/helpers/runtime-config-helper");

var _styledComponents = _interopRequireDefault(require("styled-components"));

function _templateObject() {
  var data = (0, _taggedTemplateLiteral2["default"])(["\n  cursor: ", ";\n  background-image: url(", ");\n  background-size: contain;\n  background-position-y: center;\n  width: 142px;\n  height: 41px;\n  background-repeat: no-repeat;\n  margin-left: ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var BrandImage = _styledComponents["default"].div(_templateObject(), function (props) {
  return props.cursor;
}, function (props) {
  return props.image;
}, function (props) {
  return "".concat(props.theme.spacing(2), "px");
});

var BrandLogo = function BrandLogo(_ref) {
  var _window, _window$localStorage;

  var customBrandLogo = _ref.customBrandLogo,
      linkInNewTab = _ref.linkInNewTab;
  var publicUrl = (0, _react.useMemo)(function () {
    return (0, _urlHelper.getUrl)(_urlHelper.siteNames.MY, '/home');
  }, []);

  var openBrandLogoLink = function openBrandLogoLink() {
    if (!(0, _isEmpty["default"])(publicUrl)) {
      if (linkInNewTab) {
        window.open(publicUrl, '_blank');
      } else {
        window.location = publicUrl;
      }
    }
  };

  var brandLogo = customBrandLogo || (0, _runtimeConfigHelper.getRuntimeConfig)()._brandImages.BrandLogoSVG;

  var hideLogo = (_window = window) === null || _window === void 0 ? void 0 : (_window$localStorage = _window.localStorage) === null || _window$localStorage === void 0 ? void 0 : _window$localStorage.getItem('AMUnbranded');

  if (hideLogo) {
    return null;
  }

  return /*#__PURE__*/_react["default"].createElement(BrandImage, {
    image: brandLogo,
    cursor: !(0, _isEmpty["default"])(publicUrl) ? 'pointer' : 'default',
    onClick: openBrandLogoLink
  });
};

BrandLogo.propTypes = {
  customBrandLogo: _propTypes["default"].any,
  linkInNewTab: _propTypes["default"].bool
};
BrandLogo.defaultProps = {
  linkInNewTab: false
};

var _default = (0, _react.memo)(BrandLogo);

exports["default"] = _default;